export class AppLauncher {
  applications: AppLauncherApplication[];

  constructor(applications: AppLauncherApplication[]) {
    this.applications = applications;
  }
}

export class AppLauncherApplication {
  appId: string;
  name: string;
  state: ApplicationState;
  url: string;

  constructor(appId: string, name: string, state: ApplicationState, url: string) {
    this.appId = appId;
    this.name = name;
    this.state = state;
    this.url = url;
  }
}

export enum ApplicationState {
  IS_DISABLED = 'IS_DISABLED',
  IS_ENABLED = 'IS_ENABLED',
  IS_SHOPPABLE = 'IS_SHOPPABLE'
}
